module.exports = __webpack_public_path__ + "img/img14.b5588869.jpg";